import { withLayout } from '../../../layout';

import WebhookLogsPage from './webhook-logs.page';

export default withLayout(WebhookLogsPage);
